import { useEffect, useState } from "react";
import { get_datos_oferta_erp } from "../../services/ofertas";

// Hook de càrrega inicial de dades d'una oferta.
// Rep `oferta_id`, consulta l'ERP i exposa dades, estat de càrrega i error.
export const useInitialDataOffer = (oferta_id) => {
  const [ofertas_erp, setOfertaErp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Sense id no hi ha context d'oferta a carregar.
    if (!oferta_id) {
      return;
    }

    // Carrega dades cada vegada que canvia `oferta_id`.
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await get_datos_oferta_erp(oferta_id);

        setOfertaErp(data);
      } catch (err) {
        console.error("❌ Error fetching oferta ERP:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [oferta_id]);

  // Consumit per formularis/pantalles per preomplir camps i gestionar estat UI.
  return { ofertas_erp, loading, error };
};
